import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { CreateWindowMessage } from "src/common/userMainWindow/userMainWindow-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { InvoicesListViewModel } from "../invoicesList/invoicesList-viewModel";
import { InvoicePaymentViewModel } from "../Payment/invoicePayment/invoicePayment-viewModel";
import { ReturnInvoiceRequestFormViewModel } from "../returnInvoiceRequestForm/returnInvoiceRequestForm-viewModel";
import { InvoiceDetailView } from "./invoiceDetail-view"

export class InvoiceDetailViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: InvoicesListViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.lineItems = ObservableArray.create();
        this.payments = ObservableArray.create();
    }
    GetDefaultView(): View<ViewModel> {
        return new InvoiceDetailView();
    }
    public getTypeId(): string {
        return "VM-C6D13AEE-A26A-48F8-A802-B26604F02502"
    }
    private _typedParent : InvoicesListViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set cashierName(v: string) { this._cashierName = v; } public get cashierName(): string { return this._cashierName; } private _cashierName: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber; } private _parentInvoiceNumber: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance; } private _customerAccountBalance: number;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit; } private _totalDeficit: number;
    public set additionCost(v: number) { this._additionCost = v; } public get additionCost(): number { return this._additionCost; } private _additionCost: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions; } private _totalAdditions: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set invoiceType(v: number) { this._invoiceType = v; } public get invoiceType(): number { return this._invoiceType; } private _invoiceType: number;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState; } private _warehouseState: number;
    public set payments(v: ObservableArray<payment>) { this._payments = v; } public get payments(): ObservableArray<payment> { return this._payments;} private _payments: ObservableArray<payment>;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState; } private _paymentState: number;
    public set isPrinted(v: boolean) { this._isPrinted = v; } public get isPrinted(): boolean { return this._isPrinted; } private _isPrinted: boolean;
    public set canConfirm(v: boolean) { this._canConfirm = v; } public get canConfirm(): boolean { return this._canConfirm;} private _canConfirm: boolean;
    public set canCancel(v: boolean) { this._canCancel = v; } public get canCancel(): boolean { return this._canCancel;} private _canCancel: boolean;
    public set canReturn(v: boolean) { this._canReturn = v; } public get canReturn(): boolean { return this._canReturn;} private _canReturn: boolean;
    public set canPay(v: boolean) { this._canPay = v; } public get canPay(): boolean { return this._canPay;} private _canPay: boolean;
    public set canPrint(v: boolean) { this._canPrint = v; } public get canPrint(): boolean { return this._canPrint;} private _canPrint: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;
    
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems; } private _lineItems: ObservableArray<InvoiceLineItem>;
    public set confirmationTime(v: moment.Moment) { this._confirmationTime = v; } public get confirmationTime(): moment.Moment { return this._confirmationTime;} private _confirmationTime: moment.Moment;
    
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId: string) {
        let result = await ServerConnection.callServer('Complex/SellServices/GetInvoiceDetail', {
            InvoiceId: invoiceId,
        });
        this.id = result.Id;
        this.customerName = result.CustomerName;
        this.customerId = result.CustomerId;
        this.sellerName = result.SellerName;
        this.cashierName = result.CashierName;
        this.receiverName = result.ReceiverName;
        this.creationTime = moment.utc(result.CreationTime);
        this.invoiceNumber = result.InvoiceNumber;
        this.parentInvoiceNumber = result.ParentInvoiceNumber;
        this.districtName = result.DistrictName;
        this.districtId = result.DistrictId;
        this.totalPrice = result.TotalPrice;
        this.finalPrice = result.FinalPrice;
        this.totalDeficit = result.TotalDeficits;
        this.additionCost = result.AdditionCost;
        this.totalAdditions = result.TotalAdditions;
        this.invoiceType = result.InvoiceType;
        this.warehouseState = result.WarehouseState;
        this.paymentState = result.PaymentState;
        this.isPrinted = result.IsPrinted;
        this.state = result.State;
        this.canEdit = this.invoiceType ==1 && result.State==0 && result.PaymentState==0;
        this.canConfirm = this.invoiceType == 1 && result.CanConfirm;
        this.canReturn = this.invoiceType == 1 && result.State === 2;
        this.canCancel = this.invoiceType == 1 && result.CanCancel;
        this.canPay = this.invoiceType == 1 && result.State != 3;
        this.canPrint = result.CanPrint;
        this.confirmationTime = result.ConfirmationTime ==null ? null : moment.utc(result.ConfirmationTime); 

        let warehouseNameMap : Map<string,string> = new Map<string,string>();
        if((result.IsFromRootDistrict || result.PaymentState==3 || result.PaymentState==4) || result.CanSeeWarehouseName){
            (<any[]>result.LineItems).forEach(x=>{
                if(warehouseNameMap.has(x.DeliveryWarehouseId)==false){
                    warehouseNameMap.set(x.DeliveryWarehouseId,x.DeliveryWarehouseName)
                }
            })
        }else{
            let ind=1;
            (<any[]>result.LineItems).forEach(x=>{
                if(warehouseNameMap.has(x.DeliveryWarehouseId)==false){
                    warehouseNameMap.set(x.DeliveryWarehouseId,`انبار شعب ${ind}`);
                    ind++;
                }
            })
        }

        let saleWarehouseNameMap : Map<string,string> = new Map<string,string>();
        if((result.IsFromRootDistrict || result.PaymentState==3 || result.PaymentState==4) || result.CanSeeWarehouseName){
            (<any[]>result.LineItems).forEach(x=>{
                if(saleWarehouseNameMap.has(x.SaleFromWarehouseId)==false){
                    saleWarehouseNameMap.set(x.SaleFromWarehouseId,x.SaleFromWarehouseName)
                }
            })
        }else{
            let ind=1;
            (<any[]>result.LineItems).forEach(x=>{
                if(saleWarehouseNameMap.has(x.SaleFromWarehouseId)==false){
                    saleWarehouseNameMap.set(x.SaleFromWarehouseId,`انبار شعب ${ind}`);
                    ind++;
                }
            })
        }
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new InvoiceLineItem(this);
            r.rowNumber = i + 1;
            r.saleFromWarehouseId = q.SaleFromWarehouseId;
            r.saleFromWarehouseName =saleWarehouseNameMap.get(q.SaleFromWarehouseId);
            r.deliveryWarehouseId = q.DeliveryWarehouseId;
            r.deliveryWarehouseName = warehouseNameMap.get(q.DeliveryWarehouseId);
            r.receiverId = q.ReceiverId;
            r.receiverName = q.ReceiverName;
            r.isDeliveryFormPrinted = q.IsDeliveryFormPrinted;
            r.deliveryFormPrintApplierName = q.DeliveryFormPrintApplierName;
            r.id = q.MeasuredProductId;
            r.deliveryTime = q.DeliveryTime ==null ? null : moment.utc(q.DeliveryTime); 
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.feePrice = q.FeePrice;
            r.amount = q.Amount;
            r.deficit = q.DeficitPrice;
            r.finalPrice = q.FinalPrice;
            r.totalPrice = q.TotalPrice;
            r.additionalPrice = q.AdditionalPrice;
            return r;
        }));
        this.receiverName = [...new Set(this.lineItems.map(q => q.receiverName))].join(', ');
        this.payments.update(...result.Payments.map(x=>{
            let r = new payment(this);
            r.amount = x.Amount;
            r.method = x.MethodName;
            r.status = x.Status == 1 ? 'منتظر تایید' : x.Status == 2 ? 'تایید شده' : 'رد شده';
            r.time = moment.utc(x.Time);
            return r;
        }));
        this.loadCustomerAccountBalance();
    }

    async loadCustomerAccountBalance(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CreditServices/GetCustomerCredit',{
                InvoiceId:this.id
            });
            this.customerAccountBalance = Math.abs(result.CustomerAccountBalance);
            this.accountBalanceLabel = result.CustomerAccountBalance > 0 ? 'بدهکار' : 'بستانکار';
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    back() {

    }

    async confirm() {
        try {
            let result = await ServerConnection.callServer('Complex/SellServices/ConfirmSaleInvoice', {
                InvoiceId: this.id,
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess(`فاکتور با موفقیت تایید شد.`, 'عملیات موفق');
            } else {
                if (result.Faults[0].Parameters.FaultId === "6CFFE6CC-63FC-4C3D-8976-6E1677020051")
                    throw "مانده حساب بیشتر از اعتبار مشتری است.";
                throw "خطا در انجام عملیات";
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.loadById(this.id)
        }
    }

    async cancel() {
        try {
            let r:string; 
            r = await this.messageBoxWarningYesNo('آیا مطمئنید می خواهید فاکتور لغو شود؟','لغو فاکتور');
            if(r=='no'){
                return;
            }
            let result = await ServerConnection.callServer('Complex/SellServices/CancelSaleInvoice', {
                InvoiceId: this.id,
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess(`فاکتور با موفقیت لغو شد.`, 'عملیات موفق');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this._typedParent.refresh();
            this.closePopup();
        }
    }

    async createReturnInvoice() {
        let returnRequest = new ReturnInvoiceRequestFormViewModel(this._typedParent, this.id);
        this._typedParent.showPopup(returnRequest);
        let result = await this.requestShowingPopup(returnRequest);
        if(result=='yes'){
            this._typedParent.refreshClosePopups();
        }
    }

    async showPayment(){
        let payments = new InvoicePaymentViewModel(this);
        payments.invoiceId = this.id;
        this._typedParent.showPopup(payments);
        let result = await this.requestShowingPopup(payments);
        if(result=='yes'){
            this._typedParent.refreshClosePopups();
        }
    }

    async showEditForm(){
        this.closePopup();
        let msg = new CreateWindowMessage('a3a989c6-394e-4133-a279-a34ed1a3a656');
        let editForm = await this.handleMessage(msg);
        editForm.window.loadForEdit(this.id, this.customerId, this.lineItems, this.districtId);
    }

    async printInvoice(){
        new PrintSaleFactorAction().Print(this,this.id);
    }

    closePopup() {

    }
}
export class InvoiceLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set receiverId(v: string) { this._receiverId = v; } public get receiverId(): string { return this._receiverId;} private _receiverId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName;} private _receiverName: string;
    public set isDeliveryFormPrinted(v: boolean) { this._isDeliveryFormPrinted = v; } public get isDeliveryFormPrinted(): boolean { return this._isDeliveryFormPrinted; } private _isDeliveryFormPrinted: boolean;
    public set deliveryFormPrintApplierName(v: string) { this._deliveryFormPrintApplierName = v; } public get deliveryFormPrintApplierName(): string { return this._deliveryFormPrintApplierName; } private _deliveryFormPrintApplierName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set deficit(v: number) { this._deficit = v; } public get deficit(): number { return this._deficit; } private _deficit: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set additionalPrice(v: number) { this._additionalPrice = v; } public get additionalPrice(): number { return this._additionalPrice; } private _additionalPrice: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set deliveryTime(v: moment.Moment) { this._deliveryTime = v; } public get deliveryTime(): moment.Moment { return this._deliveryTime;} private _deliveryTime: moment.Moment;
    

}

export class payment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }

    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set method(v: string) { this._method = v; } public get method(): string { return this._method;} private _method: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    
}

export class PrintSaleFactorAction{
    public async Print(parent:ViewModel, invoiceId:string):Promise<void>{
        let result = await ServerConnection.callServer('/Complex/SellServices/GetInvoiceDetail',{
            ShallPrint: true,
            InvoiceId:invoiceId
        });
        return this.PrintFromDto(parent,result);
    }

    public PrintFromDto(parent:ViewModel, result:any){
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"SellFactor",
            Data:{
                CopyCount:1,
                IsMain : !result.IsInvoicePrinted,
                SellerName:result.SellerName,
                CustomerName:result.CustomerName,
                CustomerNationalCode:result.CustomerNationalCode,
                CustomerAddress:result.CustomerAddress,
                CustomerPhoneNumber:result.CustomerPhone,
                CustomerCode:result.CustomerCode,
                DeliveryAddress:result.DeliveryAddress,
                FactorCode:result.InvoiceNumber,
                FactorDate:result.CreationTime,
                PrintTime:moment.utc(),
                FactorId:result.Id,
                TotalPrice:result.TotalPrice,
                valueAddedTax:result.TotalAdditions,
                Deficits:result.TotalDeficits,
                FinalPrice:result.FinalPrice,
                Items:result.LineItems.map((x,i)=>{
                    return {
                        RowIndex:i+1,
                        ProductCode:x.ProductCode,
                        ProductName:x.ProductName,
                        ElementCount:x.Amount,
                        Fee:x.FeePrice,
                        Total:x.TotalPrice,
                        ValueAddedTax:x.AdditionalPrice,
                        FromWarehouse:x.SaleFromWarehouseName,
                        DeliveryWarehouse:x.DeliveryWarehouseName,
                        DeficitAmount:x.DeficitPrice,
                        Payable:x.FinalPrice,
                    };
                })
            }
        });
        return parent.handleMessage(message);
    }
}
